/**
 * @generated SignedSource<<5af3bea4c8ea945c8caf17b2c65de353>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type IdentityCreateImpersonationTokenInput = {
  input?: ImpersonationTokenCreateInput | null | undefined;
};
export type ImpersonationTokenCreateInput = {
  clientMutationId: string;
};
export type UseCreateImpersonationTokenMutation$variables = {
  input: IdentityCreateImpersonationTokenInput;
};
export type UseCreateImpersonationTokenMutation$data = {
  readonly result: {
    readonly impersonationPayload: {
      readonly model: {
        readonly __typename: "EdgeOfImpersonationToken";
        readonly cursor: string;
        readonly node: {
          readonly createdAt: string;
          readonly createdByAccountType: string;
          readonly createdById: string;
          readonly hasBeenUsed: boolean;
          readonly id: string;
          readonly isDeleted: boolean;
          readonly token: string;
          readonly tokenId: string;
          readonly updatedAt: string;
          readonly updatedByAccountType: string;
          readonly updatedById: string;
        };
      } | null | undefined;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly code?: string;
      readonly message?: string;
      readonly name?: string;
    }> | null | undefined;
  };
};
export type UseCreateImpersonationTokenMutation = {
  response: UseCreateImpersonationTokenMutation$data;
  variables: UseCreateImpersonationTokenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ImpersonationPayload",
  "kind": "LinkedField",
  "name": "impersonationPayload",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EdgeOfImpersonationToken",
      "kind": "LinkedField",
      "name": "model",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IdentityImpersonationToken",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tokenId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasBeenUsed",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isDeleted",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "token",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdById",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdByAccountType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedById",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedByAccountType",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "name",
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "ElevateUserError",
  "abstractKey": "__isElevateUserError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UseCreateImpersonationTokenMutation",
    "selections": [
      {
        "alias": "result",
        "args": (v1/*: any*/),
        "concreteType": "IdentityCreateImpersonationTokenPayload",
        "kind": "LinkedField",
        "name": "identityCreateImpersonationToken",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "userErrors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UseCreateImpersonationTokenMutation",
    "selections": [
      {
        "alias": "result",
        "args": (v1/*: any*/),
        "concreteType": "IdentityCreateImpersonationTokenPayload",
        "kind": "LinkedField",
        "name": "identityCreateImpersonationToken",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "userErrors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f1e831fac42995db0e91c82ab2e82990",
    "id": null,
    "metadata": {},
    "name": "UseCreateImpersonationTokenMutation",
    "operationKind": "mutation",
    "text": "mutation UseCreateImpersonationTokenMutation(\n  $input: IdentityCreateImpersonationTokenInput!\n) {\n  result: identityCreateImpersonationToken(input: $input) {\n    impersonationPayload {\n      model {\n        __typename\n        cursor\n        node {\n          id\n          tokenId\n          hasBeenUsed\n          isDeleted\n          token\n          createdAt\n          createdById\n          createdByAccountType\n          updatedAt\n          updatedById\n          updatedByAccountType\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        name: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4414245fd3e034b1d4f2d863fa71e156";

export default node;
